import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { ConnectionDetailField } from '../ConnectionDetailField/ConnectionDetailField'

import './WebinarConnectionDetails.scss'

interface WebinarConnectionDetailsProps {
  streamingServerUrl?: string
  streamKey?: string
  connectionType?: string
}

export const WebinarConnectionDetails = ({
  streamingServerUrl,
  streamKey,
  connectionType,
}: WebinarConnectionDetailsProps) => {
  const intl = useIntl()
  const connectionTypeLabel = connectionType === 'whip' ? 'WHIP' : 'RTMP'

  if (!streamingServerUrl || !streamKey) {
    return (
      <div className="webinar-connection-details">
        <FormattedMessage defaultMessage="Streaming credentials are missing. Please try again or contact support if the problem persists." />
      </div>
    )
  }

  return (
    <div className="webinar-connection-details">
      <div className="connection-details-intro">
        <FormattedMessage
          defaultMessage="Join the meeting using {connectionTypeLabel}. Copy the details below to start streaming, or join without streaming to access them later."
          values={{ connectionTypeLabel }}
        />
      </div>
      <ConnectionDetailField
        label={<FormattedMessage defaultMessage="Streaming Server" />}
        value={streamingServerUrl}
        copyLabel={intl.formatMessage({
          defaultMessage: 'Copy streaming server URL',
        })}
      />
      <ConnectionDetailField
        label={<FormattedMessage defaultMessage="Stream Key" />}
        value={streamKey}
        copyLabel={intl.formatMessage({ defaultMessage: 'Copy stream key' })}
      />
    </div>
  )
}
